import { z } from 'zod';

export const BookingCustomQuestionSchema = z.object({
  questionId: z.string(),
  answer: z.array(
    z.object({
      value: z.union([z.string(), z.boolean()]),
      key: z
        .string()
        .optional()
        .nullable()
        .transform((key) => key || null),
    }),
  ),
});

export const BookingCustomQuestionWithAnswerSchema = BookingCustomQuestionSchema.extend({
  answerId: z.string().optional(),
});

export const BookingCustomQuestionResponseSchema = BookingCustomQuestionWithAnswerSchema;
export type BookingCustomQuestionResponse = z.infer<typeof BookingCustomQuestionResponseSchema>;
